// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"6c3b8ebd","432":"193ef64d","545":"499a8f8b","564":"d963d577","657":"1103c089","845":"0a6f2ad0"}[chunkId] + ".chunk.js";
};